import { featureFlagGuard, TempFeatureFlags } from '@rma/generic/util/feature-flags';

import { billingRoutes } from './billing.routes';

// These are routes that I haven't quite fi
export const accountRoutes = [
  {
    path: 'billing',
    children: billingRoutes,
  },
  {
    path: 'manage-account',
    loadChildren: () => import('@rma/account/manage-account'),
  },
  {
    path: 'notifications',
    loadComponent: () => import('@rma/notification-bell/view-all-notifications'),
  },
  {
    path: 'onboarding',
    canActivate: [featureFlagGuard(TempFeatureFlags.OnboardingWizardRedirect, false, { flagPredicate: (x) => !x })],
    loadChildren: () => import('@rma/account-setup/subscription-onboarding'),
  },
];
